import { forwardRef, type Ref, type SVGProps } from "react";

function SvgInstantPayWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#instant-pay-warning_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#instant-pay-warning_svg__b)" strokeWidth={20} />
      </g>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M88 41.727V38m0 37.273V79m7.796-31.682C94.24 45.09 91.331 43.591 88 43.591h-1c-4.418 0-8 2.967-8 6.626v.285c0 2.617 1.785 5.01 4.612 6.18l8.776 3.635C95.214 61.487 97 63.881 97 66.498c0 3.817-3.736 6.911-8.344 6.911H88c-3.331 0-6.24-1.499-7.796-3.727"
      />
      <rect width={39} height={39} x={29.5} y={10.5} fill="#BD6801" rx={19.5} />
      <rect width={39} height={39} x={29.5} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.51}
        d="M49 24v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="instant-pay-warning_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="instant-pay-warning_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInstantPayWarning);
export default ForwardRef;
